import React from "react";
import { useLocation } from "react-router-dom";

import LoginForm from "./form/LoginForm";
import ForgotPasswordForm from "./form/ForgotPasswordForm";
import LeftSection from "./LeftSection";
import ResetPasswordForm from "./form/ResetPasswordForm";

const MainContent = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const renderForm = () => {
    if (pathname === "/forgot-password") {
      return <ForgotPasswordForm />;
    } else if (pathname === "/reset-password") {
      return <ResetPasswordForm />;
    } else {
      return <LoginForm />;
    }
  };

  return (
    <div className="bg-gray-50 flex items-center justify-center">
      <div className="max-w-6xl w-full grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Left Section - Branding */}
        <LeftSection />

        {renderForm()}
      </div>
    </div>
  );
};

export default MainContent;
